import React from "react";

import FileUpload from "@/components/FileUpload";

interface UploadedFile {
  id: string;
  name: string;
  type: string;
  size: number;
  url: string;
  uploadDate: string;
  clientCode: string;
  category: string;
  context: string;
  analysis?: any;
  isVector?: boolean;
}


interface UploadModalProps {
  isOpen: boolean;
  onClose: () => void;
  clientCode: string;
  context: any;
  onUploadSuccess: (files: UploadedFile[]) => void;
}

const UploadModal: React.FC<UploadModalProps> = ({ isOpen, onClose, clientCode, context, onUploadSuccess }) => {
  if (!isOpen) return null;
  return (
    <FileUpload
      clientCode={clientCode}
      isOpen={isOpen}
      onClose={onClose}
      context={context}
      onUploadSuccess={onUploadSuccess}
    />
  );
};

export default UploadModal;
